import Vue from 'vue'
import Main from './main.vue'

const MConstructor = Vue.extend(Main) // 直接将Vue组件作为Vue.extend的参数

let MInstance = null
/**
 * 登录窗口
 * @param {object} options 配置
 */
const AddressBook = options => {
  return new Promise((resolve, reject) => {
    if (typeof options !== 'object') {
      reject(new Error('参数错误'))
      return
    }
    let _options = {
      title: options.title, // 要展示的弹框的title
      sandboxId: options.sandboxId || '',
      // 0: 人员 1: 部门 2: 人员tpId 3: 部门tpId 4: 人员memberId 5: 部门memberId 6: 全选  *选人不建议使用部门*
      returnType: options.returnType || 0,
      multiple: options.multiple || false, // 是否多选
      maxMember: options.multiple ? options.maxMember || 1500 : 1, // 最大可选人员
      needReturn: options.needReturn || false, // 直接退出是否需要返回
      removeDelay: options.removeDelay || 100, // 是否延时去除dom
      isSandboxComplete: options.isSandboxComplete,
      propSelectedMembers: options.propSelectedMembers || [], // 已选择人员 { memberId memberName } 必穿
      propSelectedDepts: options.propSelectedDepts || [] // 已选择部门{ deptName deptId } 必穿
    }
    // eslint-disable-next-line space-before-function-paren
    _options.close = function (result) {
      let _params = {
        removeDelay: _options.removeDelay
      }
      AddressBook.close(_params)
        .then(res => {
          resolve(result)
        })
        .catch(err => {
          reject(err)
        })
    }
    // eslint-disable-next-line space-before-function-paren
    _options.closeOnly = function () {
      let _params = {
        removeDelay: _options.removeDelay
      }
      AddressBook.close(_params)
        .then(res => {
          resolve({
            $type: this.needReturn ? 'onlyReturn' : ''
          })
        })
        .catch(err => {
          reject(err)
        })
    }
    MInstance = new MConstructor({ data: _options })

    MInstance.vm = MInstance.$mount() // 挂载但是并未插入dom，是一个完整的Vue实例
    MInstance.dom = MInstance.vm.$el
    if (!_options.appendNode) {
      document.body.appendChild(MInstance.dom) // 将dom插入body
    } else {
      document.getElementById('app').appendChild(MInstance.dom)
    }

    MInstance.vm.visible = true
  })
}

// eslint-disable-next-line
AddressBook.close = function () {
  return new Promise((resolve, reject) => {
    if (MInstance) {
      // //销毁vm实例与DOM之间的关联
      MInstance.vm.$destroy()
      window.history.go(-1)
      // 防止返回后通讯录一直盖在界面上没有消失
      let $addressDom = MInstance.dom
      $addressDom && $addressDom.remove()
      MInstance = null
    } else {
      let $addressDom = document.getElementById('$address-book$')
      $addressDom && $addressDom.remove()
    }
    resolve()
  })
}

export default AddressBook
